import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b3ad05a8")

_pushScopeId("data-v-b3ad05a8")
const _hoisted_1 = { class: "NewLtlAdditionalServices" }
const _hoisted_2 = { class: "NewLtlAdditionalServices__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h2", { class: "header__title" }, [
    /*#__PURE__*/_createTextVNode(" Дополнительные услуги "),
    /*#__PURE__*/_createVNode("span", { class: "primary" }, "при заборе")
  ]),
  /*#__PURE__*/_createVNode("p", null, "(не обязательно)")
], -1)
const _hoisted_4 = { class: "NewLtlAdditionalServices__body" }
const _hoisted_5 = { class: "NewLtlAdditionalServices__body__item" }
const _hoisted_6 = {
  key: 0,
  class: "NewLtlAdditionalServices__body__item"
}
const _hoisted_7 = { class: "NewLtlAdditionalServices__body__item" }
const _hoisted_8 = {
  key: 0,
  class: "NewLtlAdditionalServices__body__item"
}
const _hoisted_9 = { class: "NewLtlAdditionalServices__footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Продолжить ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.closable)
        ? (_openBlock(), _createBlock(_component_icon_close, {
            key: 0,
            class: "header__cancel",
            onClick: _ctx.emitClose
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_s_checkbox, {
        theme: "primary",
        label: "Манипулятор",
        value: _ctx.state.hasManipulator,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.hasManipulator = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_s_checkbox, {
        theme: "primary",
        label: "Кран",
        value: _ctx.state.hasCrane,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.hasCrane = $event))
      }, null, 8, ["value"]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_s_checkbox, {
          theme: "primary",
          label: "Рохля",
          value: _ctx.state.hasHydraulicTrolley,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.hasHydraulicTrolley = $event))
        }, null, 8, ["value"]),
        (_ctx.additionalServices.length)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("span", null, " Мин. " + _toDisplayString(_ctx.getValue('hydraulic_trolley', 'minValue')) + " часа ", 1),
              _createVNode("span", null, _toDisplayString(_ctx.getValue('hydraulic_trolley', 'price')) + " тг/час", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_s_checkbox, {
          theme: "primary",
          label: "Грузчики",
          value: _ctx.state.hasLoader,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.hasLoader = $event))
        }, null, 8, ["value"]),
        (_ctx.additionalServices.length)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("span", null, " Мин. " + _toDisplayString(_ctx.getValue('loader', 'minValue')) + " часа ", 1),
              _createVNode("span", null, _toDisplayString(_ctx.getValue('loader', 'price')) + " тг/час", 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_s_button, {
        class: "primary",
        onClick: _ctx.emitContinue
      }, {
        default: _withId(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})